import { HttpMethod } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'
import type { Login, Auth } from '~/http/auth/types'

export class AuthApi extends Http {
  login = (code: string): Promise<Auth> => {
    return this.callNoAuthAPI<Login, Auth>(
      HttpMethod.POST,
      { path: APIPaths.USER_AUTH_LOGIN },
      {
        code,
      },
    )
  }

  logout = (): Promise<null> => {
    return this.callAuthAPI<null, null>(
      HttpMethod.DELETE,
      { path: APIPaths.USER_AUTH_LOGOUT },
      null,
    )
  }
}
